
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, pluck, tap } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { addNewsFeedComments, addNewsFeedLikes, addNewsfeedMutation, allcompanyInfo, allbusinessInfo, allprofessionalInfo, allpracticeInfo, getAllNewsfeeds, practiceInfo, professionalInfo, removeNewsfeedLikes, supplierInfo, addCategoryMutation, getAllNewsfeedCategories, getNewsfeedsCount, updateNewsfeedStatusMutation, deleteNewsfeedMutation, editNewsFeedcategoryMutation, deleteCategoriesMutation, updateNewsfeedDataMutation, deleteNewsfeedCommentsMutation, updateNewsfeedCommentMutation, addNewsFeedCommentsReplys, getCommentIdData, getNewsfeedIdData, deleteNewsfeedReplysMutation, updateNewsfeedReplyMutation, getCommentReplies, getCompanyById, getNewsfeedsByUserId, monthNewsFeedCountSubscription, getNewsfeedsCategories, getFilteredNewsfeedsByCategory, getFilteredNewsfeedsCount, getCatalogueFeeds, getCatalogueFeedsCount, getJobsByFeedStatus, getJobsFeedsCount, getNewsfeedAndJobsCount, updateJobStatusMutation, deleteJobMutation, getNewsfeedIdDatajobs, getNewsfeedsByUserIds, getLearningHub, getLearningHubCount, updateLaerninghubMutation, deleteLearnHubMutation, getNewsfeedIdDataCourses, getCataloguesByIds, GET_FEED_BY_ID, getNewsfeedCategoriesByCommunity, SUPPLIER_COMMUNITY_FEEDS_COUNT, getCommunityMembersCount, getAllNewsfeedsAll } from '../quries/feeds.query';
import { ToastService } from 'src/app/core/toast.service';
import _ from 'lodash';
import { LoginService } from 'src/app/core/services/login.service';
@Injectable({
  providedIn: 'root'
})
export class FeedService {
  [x: string]: any;
  constructor(private apollo: Apollo, private toast: ToastService, private loginService: LoginService) { }
  private approvalSubject = new BehaviorSubject<boolean>(false);
  approvalStatus$ = this.approvalSubject.asObservable();


  getMonthlyNewsCount(andList, newsFeedPermissionLimit): Observable<any> {
    return this.apollo.use('external')
      .subscribe({
        query: monthNewsFeedCountSubscription,
        variables: { andList },
        fetchPolicy: 'network-only'
      })
      .pipe(
        pluck("data", "newsfeed_categories"),
        map((categories: any[]) => {
          return categories.map(category => ({
            id: category.id,
            category_name: category.category_name,
            count: newsFeedPermissionLimit - category.catalogues_aggregate?.aggregate?.count || 0
          }));
        })
      );

  }
  // data newsfeed comments 
  getNewsFeedIdData(newsfeedId: string): Observable<any> {

    return this.apollo.subscribe({
      query: getNewsfeedIdData,
      variables: { id: newsfeedId }
    }).pipe(pluck('data', 'newsfeeds'));
  }


  // getjobs comments
  getNewsFeedIdDatajobs(newsfeedId: string): Observable<any> {

    return this.apollo.subscribe({
      query: getNewsfeedIdDatajobs,
      variables: { id: newsfeedId }
    }).pipe(pluck('data', 'jobs'));
  }

  // get learnhub comments 
  getNewsfeedIdDataCourses(newsfeedId: string): Observable<any> {

    return this.apollo.subscribe({
      query: getNewsfeedIdDataCourses,
      variables: { id: newsfeedId }
    }).pipe(pluck('data', 'courses'));
  }

  getNewsFeedsCount(status: string): Observable<any> {
    return this.apollo.subscribe({
      query: getNewsfeedsCount,
      variables: { status },
    }).pipe(
      pluck('data', 'newsfeeds_aggregate', 'aggregate', 'count')
    );
  }

//   getJobsFeedsCount(status: string, communityId?: string): Observable<number> {
//   const where: any = {
//     status: { _eq: 'APPROVE' },
//     active_status: { _eq: 'ACTIVE' },
//     active_status_feed: { _eq: status }
//   };

//   if (communityId) {
//     where.community_id = { _eq: communityId };
//   } else {
//     where.community_id = { _is_null: true };
//   }

//   return this.apollo.subscribe({
//     query: getJobsFeedsCount,
//     variables: { where },
//   }).pipe(pluck('data', 'jobs_aggregate', 'aggregate', 'count'));
// }

  getJobsFeedsCount(status: string, communityId?: string, searchText?: string): Observable<number> {
    
  const where: any = {
      status: { _eq: status },
      feed_type: { _eq: 'JOBS' }
    };

    if (communityId) {
      where.community_id = { _eq: communityId };
    } else {
      where.community_id = { _is_null: true };
    }

    if (searchText && searchText.trim() !== '') {
      const searchData = `%${searchText}%`;
      where._or = [
        { description: { _ilike: searchData } },
        { title: { _ilike: searchData } },

        { admin_user: { name: { _ilike: searchData } } },
        { dental_practice: { business_name: { _ilike: searchData } } },
        { dental_supplier: { business_name: { _ilike: searchData } } },
        { dental_professional: { name: { _ilike: searchData } } },
      ];
    }

    const variables = { where };

    return this.apollo.subscribe({
      query: getCatalogueFeedsCount,
      variables,
    }).pipe(pluck('data', 'newsfeeds_aggregate', 'aggregate', 'count'));
}



//   getLearningHubCount(status: string, communityId?: string): Observable<number> {
//   const where: any = {
//     status: { _eq: 'APPROVE' },
//     active_status: { _eq: 'ACTIVE' },
//     active_status_feed: { _eq: status }
//   };

//   if (communityId) {
//     where.community_id = { _eq: communityId };
//   } else {
//     where.community_id = { _is_null: true };
//   }

//   return this.apollo.subscribe({
//     query: getLearningHubCount,
//     variables: { where },
//   }).pipe(pluck('data', 'courses_aggregate', 'aggregate', 'count'));
// }
  getLearningHubCount(status: string, communityId?: string, searchText?: string): Observable<number> {
    const where: any = {
      status: { _eq: status },
      feed_type: { _eq: 'LEARNHUB' }
    };

    if (communityId) {
      where.community_id = { _eq: communityId };
    } else {
      where.community_id = { _is_null: true };
    }

    if (searchText && searchText.trim() !== '') {
      const searchData = `%${searchText}%`;
      where._or = [
        { description: { _ilike: searchData } },
        { title: { _ilike: searchData } },

        { admin_user: { name: { _ilike: searchData } } },
        { dental_practice: { business_name: { _ilike: searchData } } },
        { dental_supplier: { business_name: { _ilike: searchData } } },
        { dental_professional: { name: { _ilike: searchData } } },
      ];
    }

    const variables = { where };

    return this.apollo.subscribe({
      query: getCatalogueFeedsCount,
      variables,
    }).pipe(pluck('data', 'newsfeeds_aggregate', 'aggregate', 'count'));
}


  getNewsFeedsCategories(): Observable<any> {
    return this.apollo.subscribe({
      query: getAllNewsfeedCategories
    }).pipe(pluck('data', 'newsfeed_categories'));
  }
  getNewsFeedsCategoriesByCommunity(communityId: string): Observable<any[]> {
    return this.apollo.watchQuery({
      query: getNewsfeedCategoriesByCommunity,
      variables: { communityId },
      fetchPolicy: 'network-only'
    })
      .valueChanges
      .pipe(pluck('data', 'newsfeed_categories'));
  }

  async addNewsfeedsLikes(addLikes): Promise<any> {

    try {

      await this.apollo.mutate({
        mutation: addNewsFeedLikes,
        variables: { addLikes }
      }).pipe(pluck('data', 'insert_newsfeeds_likes_one')).toPromise();

      return true

    } catch (err) {
      console.log(err);

    }

  }

  async addNewsfeedComments(addCommentsData): Promise<any> {

    try {
      const data = await this.apollo.mutate({
        mutation: addNewsFeedComments,
        variables: { addCommentsData }
      }).pipe(pluck('data', 'insert_news_feeds_comments_one')).toPromise();
      this.toast.openSnackBar('Your Comment Added Successfully');
      return data;


    } catch (err) {
      console.log(err);
      this.toast.openSnackBar(
        'You faild to add your comment'
      );

    }

  }

  async addNewsfeedCommentsReplys(addReplyData): Promise<any> {
    try {
      const data = await this.apollo.mutate({
        mutation: addNewsFeedCommentsReplys,
        variables: { addReplyData }
      }).pipe(pluck('data', 'insert_news_feeds_comments_replys_one')).toPromise();
      this.toast.openSnackBar('Your Reply Added Successfully');
      return data;
    } catch (err) {
      console.log(err);
      this.toast.openSnackBar('You failed to add your Reply');
    }
  }

  removeNewsLikes(userId: string, feedId: string): Observable<any> {
    return this.apollo.subscribe({
      query: removeNewsfeedLikes,
      variables: { userId, feedId }
    }).pipe(pluck('data', 'delete_newsfeeds_likes'));
  }

  getUserProfileProfessional(id) {
    return this.apollo.use("external").subscribe({
      query: professionalInfo,
      variables: { id }
    }).pipe(pluck('data', 'dental_professionals_by_pk'));
  }

  getCompanyDetails(id: string) {
    return this.apollo.use("external").watchQuery({
      query: getCompanyById,
      variables: { id }
    }).valueChanges.pipe(
      map((res: any) => res.data?.directories?.[0] || null)
    );
  }

  getUserProfileSuplier(id: any): Observable<any> {

    return this.apollo.subscribe({
      query: supplierInfo,
      variables: { id }
    }).pipe(pluck('data', 'dental_suppliers_by_pk'));
  }

  getUserProfilePracice(id) {
    return this.apollo.use("external").subscribe({
      query: practiceInfo,
      variables: { id }
    }).pipe(pluck('data', 'dental_practices_by_pk'));
  }

  addNewsfeed(newsfeed: any): Promise<any> {
    return this.apollo.mutate({
      mutation: addNewsfeedMutation,
      variables: {
        object: newsfeed
      }
    }).toPromise();
  }

  editNewsFeedCategory(categoryId: string, categoryName: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: editNewsFeedcategoryMutation,
        variables: {
          id: categoryId,
          categoryName: categoryName,
        },
      })
      .toPromise()
  }
  updateNewsfeedStatus(newsfeedId: string, newStatus: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: updateNewsfeedStatusMutation,
        variables: {
          id: newsfeedId,
          status: newStatus,
        },
      })
      .toPromise()
  }
  updateJobStatus(jobId: string, newStatus: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: updateJobStatusMutation,
        variables: {
          id: jobId,
          active_status_feed: newStatus,
        },
      })
      .toPromise();
  }
  updateLaerningHub(learnId: string, newStatus: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: updateLaerninghubMutation,
        variables: {
          id: learnId,
          active_status_feed: newStatus,
        },
      })
      .toPromise();
  }

  updateNewsfeedComments(commentId: string, updatedComment: any): Promise<any> {
    return this.apollo.mutate({
      mutation: updateNewsfeedCommentMutation,
      variables: {
        id: commentId,
        data: updatedComment
      }
    }).toPromise();
  }

  updateNewsfeedReply(replyId: string, updatedReply: any): Promise<any> {
    return this.apollo.mutate({
      mutation: updateNewsfeedReplyMutation,
      variables: {
        id: replyId,
        data: updatedReply
      }
    }).toPromise();
  }

  getNewsfeedComments(id): Observable<any> {
    return this.apollo.subscribe({
      query: getCommentIdData,
      variables: { id },
    }).pipe(tap({
      next: (res) => console.log('GraphQL Response:', res),
    }),
      pluck('data', 'news_feeds_comments')
    );
  }

  updateNewsfeedData(newsfeedId: string, feedData: any): Promise<any> {
    return this.apollo
      .mutate({
        mutation: updateNewsfeedDataMutation,
        variables: {
          id: newsfeedId,
          data: { ...feedData },
        },
      })
      .toPromise()
  }

  deleteNewsfeed(newsfeedId: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: deleteNewsfeedMutation,
        variables: {
          id: newsfeedId,
        },
      })
      .toPromise()
  }
  deleteJob(jobId: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: deleteJobMutation,
        variables: {
          id: jobId,
        },
      })
      .toPromise()
  }
  deleteLearnHub(LearnHubId: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: deleteLearnHubMutation,
        variables: {
          id: LearnHubId,
        },
      })
      .toPromise()
  }

  deleteNewsfeedComments(newsfeedId: string): Promise<any> {

    return this.apollo
      .mutate({
        mutation: deleteNewsfeedCommentsMutation,
        variables: {
          id: newsfeedId,
        },
      })
      .toPromise()
  }

  deleteNewsfeedReply(newsfeedId: string): Promise<any> {

    return this.apollo
      .mutate({
        mutation: deleteNewsfeedReplysMutation,
        variables: {
          id: newsfeedId,
        },
      })
      .toPromise()
  }
  getCommentReplies() {
    return this.apollo.subscribe({
      query: getCommentReplies,
    }).pipe(pluck('data', 'news_feeds_comments_replys'));
  }

  getAllUserProfilePracice(limit: number, offset: number, loginID: any, loginType: string) {

      let whereCondition = {};

  switch (loginType) {
    case 'PROFESSIONAL':
      whereCondition = { dental_professional_id: { _eq: loginID } };
      break;
    case 'SUPPLIER':
      whereCondition = { dental_supplier_id: { _eq: loginID } };
      break;
    case 'PRACTICE':
      whereCondition = { dental_practice_id: { _eq: loginID } };
      break;
    case 'ADMIN':
      whereCondition = { dental_admin_id: { _eq: loginID } };
      break;
    default:
      whereCondition = {}; 
  }

    return this.apollo.use("external").watchQuery({
      query: allpracticeInfo,
      variables: { limit, offset, where: whereCondition },
    }).valueChanges.pipe(pluck('data', 'dental_practices'));
  }

  getAllUserProfileProfessional(limit: number, offset: number, loginID: any, loginType: string) {
   let whereCondition = {};

  switch (loginType) {
    case 'PROFESSIONAL':
      whereCondition = { dental_professional_id: { _eq: loginID } };
      break;
    case 'SUPPLIER':
      whereCondition = { dental_supplier_id: { _eq: loginID } };
      break;
    case 'PRACTICE':
      whereCondition = { dental_practice_id: { _eq: loginID } };
      break;
    case 'ADMIN':
      whereCondition = { dental_admin_id: { _eq: loginID } };
      break;
    default:
      whereCondition = {}; 
  }
    return this.apollo.use("external").watchQuery({
      query: allprofessionalInfo,
      variables: { limit, offset, where: whereCondition},
    }).valueChanges.pipe(pluck('data', 'dental_professionals'));
  }

  getAllUserProfileBusiness(limit: number, offset: number, loginID: any, loginType: string) {
    let whereCondition = {};

  switch (loginType) {
    case 'PROFESSIONAL':
      whereCondition = { dental_professional_id: { _eq: loginID } };
      break;
    case 'SUPPLIER':
      whereCondition = { dental_supplier_id: { _eq: loginID } };
      break;
    case 'PRACTICE':
      whereCondition = { dental_practice_id: { _eq: loginID } };
      break;
    case 'ADMIN':
      whereCondition = { dental_admin_id: { _eq: loginID } };
      break;
    default:
      whereCondition = {}; 
  }

    return this.apollo.use("external").watchQuery({
      query: allbusinessInfo,
      variables: { limit, offset, where: whereCondition }
    }).valueChanges.pipe(pluck('data', 'dental_suppliers'));
  }


  getAllComapnyName() {
    return this.apollo.use("external").subscribe({
      query: allcompanyInfo,
    }).pipe(pluck('data', 'directories'));
  }

  addCategories(category: any): Promise<any> {
    return this.apollo.mutate({
      mutation: addCategoryMutation,
      variables: {
        object: category
      }
    }).toPromise();
  }

  deleteCategories(categoryId: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: deleteCategoriesMutation,
        variables: {
          id: categoryId,
        },
      })
      .toPromise()
  }
  updateApprovalStatus(status: boolean) {
    this.approvalSubject.next(status);
  }


  transformToHierarchy(comments: any): any[] {
    return comments.map(comment => {
      const transformedComment = { ...comment };
      if (comment.comment_reply && comment.comment_reply.length) {
        transformedComment.comment_reply = this.buildReplyHierarchy(
          comment.comment_reply,
          comment.id
        );
      }
      return transformedComment;
    });
  }
  buildReplyHierarchy(replies: any, parentId: string): any[] {
    const topLevelReplies = replies.filter(reply => reply.reply_id === parentId);
    return topLevelReplies.map(reply => {
      const replyWithChildren = { ...reply };
      replyWithChildren.replies = this.buildReplyHierarchy(replies, reply.id);
      return replyWithChildren;
    });
  }


  getNewsfeedsByUserId(userId: string, userRole: string): Observable<any> {
    return this.apollo.query({
      query: getNewsfeedsByUserId,
      variables: {
        userId,
        userRole
      },
      fetchPolicy: 'network-only'
    }).pipe(
      map(result => result.data['newsfeeds'])
    );
  }


  getNewsfeedsByUserIds(
    userId: string,
    userRole: string,
    limit: number,
    offset: number
  ): Observable<any> {
    return this.apollo.query({
      query: getNewsfeedsByUserIds,
      variables: {
        userId,
        userRole,
        limit,
        offset
      },
      fetchPolicy: 'network-only'
    }).pipe(
      map(result => result.data['newsfeeds'])
    );
  }


  getNewsfeedCategories(): Observable<any[]> {
    return this.apollo.query({
      query: getNewsfeedsCategories,
    }).pipe(pluck('data', 'newsfeeds_categories'));
  }

  getFilteredNewsFeeds(
    status: string,
    limit: number,
    offset: number,
    categoryIds: string[],
    communityId?: string,
     searchText?: string,
    userId?:string,
    roleType?:string
  ): Observable<any[]> {
    const where: any = {
      status: { _eq: status },
      category_type: { _in: categoryIds },
    };
    if (communityId) {

      where.community_id = { _eq: communityId };
    } else {
      where.community_id = { _is_null: true };
    }

      // search text
     if (searchText && searchText.trim() !== '') {

    const searchData = `%${searchText}%`;
     where._or = [
       { description: { _ilike: searchData } },
       { title: { _ilike: searchData } },

     { admin_user: { name: { _ilike: searchData } } },
      { dental_practice: { business_name: { _ilike: searchData } } },
      { dental_supplier: { business_name: { _ilike: searchData } } },
      { dental_professional: { name: { _ilike: searchData } } },
    
     ];
   }
    
    return this.apollo.use('external')
      .watchQuery({
        query: getFilteredNewsfeedsByCategory,
        variables: { where, limit, offset , userId , roleType },
        fetchPolicy: 'network-only'
      })
      .valueChanges.pipe(pluck('data', 'newsfeeds'));
  }





  getFilteredNewsFeedsCount(status: string, categoryIds: string[], communityId?: string, searchText?: string): Observable<number> {
  const where: any = {
    status: { _eq: status },
    category_type: { _in: categoryIds }
  };

  if (communityId) {
    where.community_id = { _eq: communityId };
  } else {
    where.community_id = { _is_null: true };
  }

  if (searchText && searchText.trim() !== '') {
    const searchData = `%${searchText}%`;
    where._or = [
      { description: { _ilike: searchData } },
      { title: { _ilike: searchData } },
      { admin_user: { name: { _ilike: searchData } } },
      { dental_practice: { business_name: { _ilike: searchData } } },
      { dental_supplier: { business_name: { _ilike: searchData } } },
      { dental_professional: { name: { _ilike: searchData } } },
    ];
  }


  return this.apollo.subscribe({
    query: getFilteredNewsfeedsCount,
    variables: { where },
  }).pipe(pluck('data', 'newsfeeds_aggregate', 'aggregate', 'count'));
}


  getCatalogueFeeds(status: string, limit: number, offset: number, communityId?: string): Observable<any> {
   
    const where: any = {
      status: { _eq: status }
    };
    if (communityId) { 
      where.community_id = { _eq: communityId };
    } else {
      where.community_id = { _is_null: true };
    }

    const variables = { where, limit, offset };

    return this.apollo.subscribe({
      query: getCatalogueFeeds,
      variables,
    }).pipe(pluck('data', 'newsfeeds'));
  }


  getCatalogueFeedsCount(status: string, communityId?: string, searchText?: string): Observable<number> {
    const where: any = {
      status: { _eq: status },
      feed_type: { _eq: 'CATALOGUE' }
    };

    if (communityId) {
      where.community_id = { _eq: communityId };
    } else {
      where.community_id = { _is_null: true };
    }

    // Catalogue Scheduler Filter
    const today = new Date();
    today.setUTCHours(0, 0, 0, 0);

    where.catalogues = {
      schedulerDay: { _lte: today.toISOString() }
    };

       if (searchText && searchText.trim() !== '') {
         const searchData = `%${searchText}%`;
         where._or = [
           { description: { _ilike: searchData } },
           { title: { _ilike: searchData } },

           { admin_user: { name: { _ilike: searchData } } },
           { dental_practice: { business_name: { _ilike: searchData } } },
           { dental_supplier: { business_name: { _ilike: searchData } } },
           { dental_professional: { name: { _ilike: searchData } } },
         ];
       }


    const variables = { where };

    return this.apollo.subscribe({
      query: getCatalogueFeedsCount,
      variables,
    }).pipe(pluck('data', 'newsfeeds_aggregate', 'aggregate', 'count'));
  }


  getNewsFeeds(status: string, limit: number, offset: number, communityId?: string): Observable<any> {
    const where: any = {
      status: { _eq: status }
    };
    // Critical part: filter properly
    if (communityId) {
      where.community_id = { _eq: communityId };
    } else {
      where.community_id = { _is_null: true };
    }
    const variables: any = {
      where,
      limit,
      offset
    };
    return this.apollo.subscribe({
      query: getAllNewsfeeds,
      variables,
      fetchPolicy: 'network-only'
    }).pipe(pluck('data', 'newsfeeds'));
  }

  getJobsByActiveFeedStatus(feedStatus: string, limit?: number, offset?: number, communityId?: string): Observable<any[]> {
    
    const where: any = {
      status: { _eq: "APPROVE" },
      active_status: { _eq: "ACTIVE" },
      active_status_feed: { _eq: feedStatus }
    };
    if (communityId) {
      where.community_id = { _eq: communityId };
    } else {
      where.community_id = { _is_null: true };
    }

    return this.apollo.use('external').subscribe({
      query: getJobsByFeedStatus,
      variables: { where, limit, offset },
      fetchPolicy: 'network-only'
    }).pipe(pluck('data', 'jobs'));
  }


  getLearningHub(feedStatus?: string, limit?: number, offset?: number, communityId?: string): Observable<any[]> {
    const where: any = {
      status: { _eq: "APPROVE" },
      active_status: { _eq: "ACTIVE" },
      active_status_feed: { _eq: feedStatus }
    };
    if (communityId) {
      where.community_id = { _eq: communityId };
    } else {
      where.community_id = { _is_null: true };
    }

    return this.apollo.use('external').subscribe({
      query: getLearningHub,
      variables: { where, limit, offset },
      fetchPolicy: 'network-only'
    }).pipe(pluck('data', 'courses'));
  }


  getCombinedFeeds(status: string, limit: number, offset: number , communityId?: string): Promise<any[]> {
    const newsPromise = this.getNewsFeeds(status, limit, offset , communityId).toPromise();
    const jobsPromise = this.getJobsByActiveFeedStatus(status, limit, offset ,communityId).toPromise();
    const LearningHubPromise = this.getLearningHub(status, limit, offset ,communityId).toPromise();

    
    return Promise.all([newsPromise, jobsPromise, LearningHubPromise]).then(([newsfeeds, jobs, learningHub]) => {
      const formattedNewsfeeds = newsfeeds.map(item => ({
        ...item,
        __type: 'newsfeed',
        updated_at: new Date(item.updated_at)
      }));

      const formattedJobs = jobs.map(item => ({
        ...item,
        __type: 'job',
        updated_at: new Date(item.updated_at)
      }));
      const formattedlearnHub = learningHub.map(item => ({
        ...item,
        __type: 'learnHub',
        updated_at: new Date(item.updated_at)
      }));

      const combined = [...formattedNewsfeeds, ...formattedJobs, ...formattedlearnHub].sort(
        (a, b) => b.updated_at.getTime() - a.updated_at.getTime()
      );
      return combined;
    });
  }

  getAllNewsfeedAndJobsCounts(communityId?: string, searchText?: string): Observable<any> {

    const where: any = {};

      if (communityId) {
    where.community_id = { _eq: communityId };
  } else {
    where.community_id = { _is_null: true };
  }

  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);

  // catalogue scheduler rule
  where._and = [
    {
      _or: [
        { feed_type: { _neq: "CATALOGUE" } },
        {
          feed_type: { _eq: "CATALOGUE" },
          catalogues: { schedulerDay: { _lte: today } }
        }
      ]
    }
  ];

  if (searchText && searchText.trim() !== '') {
    const searchData = `%${searchText}%`;
    where._or = [
      { description: { _ilike: searchData } },
      { title: { _ilike: searchData } },
      { admin_user: { name: { _ilike: searchData } } },
      { dental_practice: { business_name: { _ilike: searchData } } },
      { dental_supplier: { business_name: { _ilike: searchData } } },
      { dental_professional: { name: { _ilike: searchData } } },
    ];
  }



    return this.apollo.subscribe({
      query: getNewsfeedAndJobsCount,
       variables: { where },
    }).pipe(pluck('data'));
  }



  getCataloguesByIds(ids: string[]): Observable<any> {
    return this.apollo.query({
      query: getCataloguesByIds,
      variables: { ids },
    }).pipe(pluck('data', 'catalogues'));
  }

  getfeedDataPreloginByid(payloadId: string): Observable<any> {
    return this.apollo.query<any>({
      query: GET_FEED_BY_ID,
      variables: { id: payloadId },
      fetchPolicy: 'network-only'
    }).pipe(
      map(res => {
        return res.data.newsfeeds;
      })
    );
  }

  getSupplierCommunityFeedsCountByCommunity(communityId: string, status: string, searchText?: string) {

    const where: any ={
      community_id: {_eq:communityId},
    }

      if (status) {
        where.status = { _eq: status };
      }

      if (searchText && searchText.trim() !== '') {
        const searchData = `%${searchText}%`;
        where._or = [
          { description: { _ilike: searchData } },
          { title: { _ilike: searchData } },
          { admin_user: { name: { _ilike: searchData } } },
          { dental_practice: { business_name: { _ilike: searchData } } },
          { dental_supplier: { business_name: { _ilike: searchData } } },
          { dental_professional: { name: { _ilike: searchData } } },
        ];
      }

    return this.apollo.watchQuery<any>({
      query: SUPPLIER_COMMUNITY_FEEDS_COUNT,
      variables: { where },
      fetchPolicy: 'network-only'
    })
    .valueChanges
    .pipe(
      map(res => res?.data?.newsfeeds_aggregate?.aggregate?.count || 0)
    );
  }


getCommunityMembersTotalCount(communityId: string): Observable<{ name: string; count: number }> {
  const where = { community_id: { _eq: communityId } };

  return this.apollo
    .watchQuery({
      query: getCommunityMembersCount,
      variables: { where },
      fetchPolicy: 'network-only',
    })
    .valueChanges.pipe(
      map((res: any) => ({
        name: res.data.community_members?.[0]?.dental_suppliers?.business_name ,
        count: res.data.community_members_aggregate?.aggregate?.count || 0,
      }))
    );
}


// newly implement feed--


getNewsFeedsAllData(
  status: string,
  limit: number,
  offset: number,
  communityId?: string,
  feedType?: string,
  searchText?: string,
  userId?:string,
  roleType?:string,
): Promise<any> {
  const where: any = {
    status: { _eq: status }
  };
  console.log('--------feedType----------',feedType)
  if (communityId) {
    where.community_id = { _eq: communityId };
  } else {
    where.community_id = { _is_null: true };
  }

    if (feedType && feedType.trim() !== '') {
      where.feed_type = { _eq: feedType };
    }

const today = new Date();
today.setUTCHours(0, 0, 0, 0);


where._and = [
  {
    _or: [
      
      { feed_type: { _neq: 'CATALOGUE' } },
      {
        feed_type: { _eq: 'CATALOGUE' },
        catalogues: { schedulerDay: { _lte: today } }
      }
    ]
  }
];

    // search text
   if (searchText && searchText.trim() !== '') {

    const searchData = `%${searchText}%`;
     where._or = [
       { description: { _ilike: searchData } },
       { title: { _ilike: searchData } },

     { admin_user: { name: { _ilike: searchData } } },
      { dental_practice: { business_name: { _ilike: searchData } } },
      { dental_supplier: { business_name: { _ilike: searchData } } },
      { dental_professional: { name: { _ilike: searchData } } },
    
     ];
   }

   
   const variables: any = { where, limit, offset , userId , roleType };

  return this.apollo
    .subscribe({
      query: getAllNewsfeedsAll,
      variables,
      fetchPolicy: 'network-only'
    })
    .pipe(pluck('data', 'newsfeeds'))
    .toPromise(); // ← convert Observable → Promise
}




}




